import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { RouteConfig } from 'react-router-config'

import { routes } from '@/routers'

import { intercomHandle } from '@/utils/intercom'

type IRouteConfigItem = RouteConfig & { main: boolean }

const convertRoutes2Map = (routes: IRouteConfigItem[], map: Record<string, IRouteConfigItem> = {}) => {
  routes.forEach((item) => {
    if (item?.path && item?.main) {
      map[item?.path] = true
    }

    if (item?.routes) {
      return convertRoutes2Map(item?.routes, map)
    }
  })

  return map
}

/**
 * 一级页面路由 map
 */
const routesMap = convertRoutes2Map(routes) || {}

const MyComponent = ({ history }) => {
  useEffect(() => {
    const cb = (location) => {
      if (!routesMap[location?.pathname]) {
        intercomHandle?.hidden()
      } else {
        intercomHandle?.show()
      }
    }

    history?.listen?.(cb)

    cb?.(location)

    return () => {
      history?.unListen?.(cb)
    }
  }, [history])

  return <></>
}

export default withRouter(MyComponent)
